import { InputForm, SubmitButton, Textarea, Error } from "components";
import PreviewReadingMaterial from "./PreviewReadingMaterial";
import {
  ReadingMaterialError,
  ReadingMaterialInput,
  ReadingMaterialProps,
} from "../../store/actionType";

interface Props {
  rMData?: ReadingMaterialProps;
  onClose: () => void;
  formData: ReadingMaterialInput;
  error: ReadingMaterialError;
  handleSubmit: React.MouseEventHandler<HTMLButtonElement>;
  handleChange: (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement>) => void;
  loading: boolean;
  header: string;
  previewUrl?: string | null;
}
const ReadingMaterialForm: React.FC<Props> = ({
  rMData,
  error,
  formData,
  handleChange,
  handleSubmit,
  loading,
  header,
  previewUrl
}) => {
  return (
    <div className="flex  p-4 overflow-hidden items-center border rounded-lg shadow-md">
      <form className="w-2/5 flex flex-col gap-4 me-4 px-2">
      <h2 className="text-lg font-bold">{header}</h2>
        <div>
          <InputForm
            id="name"
            name="name"
            label="RM Name"
            onChange={handleChange}
            value={formData?.name}
          />
          {error?.name && <Error>{error.name}</Error>}
        </div>
        <div>
          <InputForm
            id="pdf"
            name="pdf"
            label="Upload RM"
            onChange={handleChange}
            type="file"
          />
          {error?.pdf && <Error>{error.pdf}</Error>}
        </div>
        <div>
          <Textarea
            id="description"
            name="description"
            label="Description"
            onChange={handleChange}
            value={formData?.description}
          />
          {error?.description && <Error>{error.description}</Error>}
        </div>
        <SubmitButton className="w-2/5" loading={loading}  onClick={handleSubmit}/>
      </form>
      <div className="w-3/5">
        <PreviewReadingMaterial rMData={rMData} previewUrl={previewUrl} />
      </div>
    </div>
  );
};
export default ReadingMaterialForm;
